export const isSet = value => value !== undefined && value !== null;
